import type { DeviceType } from '@seek/chalice-types';

import { getCurrentDevice } from 'src/modules/chalice-user-agent/device-detect';
import { getUserAgent } from 'src/modules/chalice-user-agent/isomorphic-useragent';
import { logger } from 'src/modules/logger';

export const isSupportedIosVersion = (): boolean => {
  const minSupportedVersion = 13;
  const userAgent = getUserAgent();
  const isIosDevice = /iPhone|iPad/i.test(userAgent);

  if (!isIosDevice) {
    return true;
  }

  const userAgentRegexMatch = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);

  if (!userAgentRegexMatch) {
    logger.info(
      {
        input: {
          userAgent,
        },
      },
      'BranchIO: Failed iOS userAgent regex match',
    );
    return false;
  }

  const version = parseInt(userAgentRegexMatch[1], 10) || 12;
  return version >= minSupportedVersion;
};

const BRANCH_TARGET_DEVICES: DeviceType[] = ['iOS', 'Android', 'Desktop'];

export const isATargetDevice = (): boolean => {
  const currentDevice = getCurrentDevice();
  return BRANCH_TARGET_DEVICES.includes(currentDevice);
};

export const canShowAppBanner = ({
  isBranchEnabledFlag,
}: {
  isBranchEnabledFlag: boolean;
}) => {
  const shouldShowBranchInterstitial =
    isBranchEnabledFlag && isSupportedIosVersion();

  return {
    shouldShowBranchInterstitial,
  };
};
